export class MarkdownServiceProperties {
    public automaticallyNotLinkedOpenPopup?: boolean = false;
    public hideActions?: boolean = false;
    public markdownId?: string;
}
